// extracted by mini-css-extract-plugin
module.exports = {"newMember":"NewMember_newMember__2SN8G","newMemberForm":"NewMember_newMemberForm__OLtml","header":"NewMember_header__28BMm","formButton":"NewMember_formButton__32V80"};